module.exports = new __parcel__URL__("NoNameLogo825x638.2b79a885.png").toString();